module.exports = __webpack_public_path__ + "img/NRaider64_ua.c9dfd3d5.webp";